import Stack from '@mui/material/Stack';
import useMediaQuery from '@mui/system/useMediaQuery';
import React from 'react';

import { useAppSelector } from '@/App/hooks';
import { theme } from '@/App/theme';
import { AnnualSignWrapper } from '@/components/layout/AppBar/AppInfo/AnnualSignWrapper';
import { TodayWrapper } from '@/components/layout/AppBar/AppInfo/TodayWrapper';
import { selectAppInfo } from '@/features/info/selectAppInfo';

export const AppInfo: React.FC = () => {
  const info = useAppSelector(selectAppInfo);
  const { date, dateAnnualSign, yearAnnualSign } = info;

  const matches = useMediaQuery(theme.breakpoints.up('md'));

  if (!date || !dateAnnualSign || !yearAnnualSign) {
    return null;
  }

  return (
    <Stack direction="row" spacing={matches ? 2 : 1} sx={{ alignItems: 'center', marginBottom: '4px' }}>
      <TodayWrapper date={date} />
      <AnnualSignWrapper id="SH.COMMON.YEAR" value={yearAnnualSign} />
      <AnnualSignWrapper id="SH.COMMON.DAY" value={dateAnnualSign} />
    </Stack>
  );
};
